import { useEffect } from "react";
import { getProfile } from "../Apiservices/Auth/servers/profileServer";
import { useDispatch } from 'react-redux';
import { setUserDetails } from "../store/userSlice";


export const UseMyaccount = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProfile();
        

        // Dispatch only required fields
        dispatch(setUserDetails(response));
      } catch (error) {
        console.error("Error editing basic info:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  return null; 
}